import React from 'react'
import CopyPlan from '../../plan/CopyPlan'
import V3PlanRouteShell from './V3PlanRouteShell'

export default function V3CopyPlanPage() {
  return (
    <V3PlanRouteShell>
      <CopyPlan visualVariant="v3" />
    </V3PlanRouteShell>
  )
}

